import _ from 'lodash';

//Shanks - get rid of this file with app seperation

const branding = {
  MM: {
    name: 'MassMutual',
    code: 'MM',
  },
  CAS: {
    name: 'MassMutual',
    code: 'CAS',
  },
  LifeBridge: {
    name: 'MassMutual',
    code: 'LifeBridge',
  },
  HealthBridge: {
    name: 'MassMutual',
    code: 'HealthBridge',
  },
  AgeUp: {
    name: 'AgeUp',
    code: 'AgeUp',
  },
};

const carrier = {
  HAVE: {
    name: 'MassMutual',
    code: 'HAVE',
  },
  CAS: {
    name: 'MassMutual',
    code: 'CAS',
  },
  CMLIFE: {
    name: 'CMLife',
    code: 'CMLIFE',
  },
  AGEUP: {
    name: 'MassMutual',
    code: 'AGEUP',
  },
  MASM: {
    name: 'MassMutual',
    code: 'MASM',
  },
};

const channelGroups = {
  HIT: {
    name: 'HIT',
  },
  MM: {
    name: 'MM',
  },
};

const channels = {
  CAS: {
    code: 'CAS',
    name: 'MassMutual',
    emailBranding: branding.MM,
    carrier: carrier.CAS,
    fromEmail: 'no-reply@coverpath.com',
    helpEmail: 'DigitalCustomerSupport@massmutual.com',
    phone: '1-866-618-7797',
    policyPhone: '1-844-768-6774',
    group: channelGroups.HIT,
    homeOfficeAddress: '1295 State Street, Springfield, MA 01111',
    adminOfficeAddress: '60 Madison Avenue, 7th Floor, New York, NY 10010-1624',
    productCodes: {
      CASTerm: 'CASTerm',
      CASTermECP: 'CASTermECP',
      CPL100: 'CPL100',
      CPL100A: 'CPL100A',
      CPL65: 'CPL65',
      CPL65A: 'CPL65A',
      CPL10: 'CPL10',
      CPL10A: 'CPL10A',
      CPL12: 'CPL12',
      CPL15: 'CPL15',
      CPL15A: 'CPL15A',
      CPL20: 'CPL20',
      CPL20A: 'CPL20A',
      CASREC: 'CASREC',
      CASRE: 'CASRE',
      CASSV: 'CASSV',
    },
    productTypes: {},
  },
  MMDirect: {
    code: 'MMDirect',
    name: 'MMDirect',
    emailBranding: branding.MM,
    carrier: carrier.CAS,
    fromEmail: 'no-replyDirectTerm@massmutual.com',
    helpEmail: 'supportDirectTerm@massmutual.com',
    phone: '1-844-611-1027',
    policyPhone: '1-844-768-6774',
    group: channelGroups.HIT,
    homeOfficeAddress: '1295 State Street, Springfield, MA 01111',
    adminOfficeAddress: '60 Madison Avenue, 7th Floor, New York, NY 10010-1624',
    productCodes: {
      MMDirectTerm: 'MMDirectTerm',
      MMDirectTermECP: 'MMDirectTermECP',
    },
    productTypes: {},
  },
  LifeBridge: {
    code: 'LifeBridge',
    name: 'LifeBridge',
    emailBranding: branding.MM,
    carrier: carrier.CAS,
    fromEmail: 'no-replyDirectTerm@massmutual.com',
    helpEmail: 'supportDirectTerm@massmutual.com',
    phone: '1-844-611-1027',
    policyPhone: '1-844-768-6774',
    group: channelGroups.HIT,
    homeOfficeAddress: '1295 State Street, Springfield, MA 01111',
    adminOfficeAddress: '60 Madison Avenue, 7th Floor, New York, NY 10010-1624',
    productCodes: {
      ET10: 'ET10',
    },
    productTypes: {},
  },
  AgeUp: {
    code: 'AgeUp',
    name: 'AgeUp',
    emailBranding: branding.AgeUp,
    carrier: carrier.AGEUP,
    fromEmail: 'no-reply@age-up.com',
    helpEmail: 'help@age-up.com',
    phone: '1-888-452-4387',
    policyPhone: '1-888-452-4387',
    group: channelGroups.HIT,
    productCodes: {
      AgeUp: 'AgeUpDIA',
    },
    productTypes: {
      DIA: 'DIA',
    },
  },
  MMTRAD: {
    code: 'MMTRAD', //For sanderling product, we are using `MMTRADTerm`; For sanderling channel, we are uing `MMTRAD`.
    name: 'MMTRAD',
    emailBranding: branding.MM,
    carrier: carrier.MASM,
    fromEmail: 'no-replysupport@coverpath.com',
    helpEmail: 'DigitalCustomerSupport@massmutual.com',
    phone: '1-866-957-5347',
    policyPhone: '1-866-957-5347',
    group: channelGroups.MM,
    productCodes: {
      MMTRADTerm: 'MMTRADTerm',
      MMTRADTermECP: 'MMTRADTermECP',
      MMTRADWL100: 'MMTRADWL100',
      MMTRADWL65: 'MMTRADWL65',
      MMTRADWL20: 'MMTRADWL20',
    },
    productTypes: {},
  },
  MMOPM: {
    code: 'MMOPM', // For sanderling
    name: 'MMOPM',
    emailBranding: branding.MM,
    carrier: carrier.MASM,
    fromEmail: 'no-replysupport@coverpath.com',
    helpEmail: 'DigitalCustomerSupport@massmutual.com',
    phone: '1-866-957-5347',
    policyPhone: '1-866-957-5347',
    group: channelGroups.MM,
    productCodes: {
      MMOPMTerm: 'MMOPMTerm',
      MMOPMTermAPT80: 'MMOPMTermAPT80',
    },
    productTypes: {},
  },
};

const productGroups = {
  LIFE: {
    name: 'LIFE',
  },
  DI: {
    name: 'Life DI',
  },
  ANNUITY: {
    name: 'ANNUITY',
  },
};

export const productTypes = {
  ConvertTerm: {
    code: 'ConvertTerm',
    name: 'Convertible Term',
    group: productGroups.LIFE,
    productCodes: {},
  },
  Term: {
    code: 'Term',
    name: 'Term Life',
    group: productGroups.LIFE,
    productCodes: {
      CASTerm: 'CASTerm',
      CASTermECP: 'CASTermECP',
      MMDirectTerm: 'MMDirectTerm',
      MMDirectTermECP: 'MMDirectTermECP',
      ET10: 'ET10',
      ET03: 'ET03',
    },
  },
  Whole: {
    code: 'Whole',
    name: 'Whole Life',
    group: productGroups.LIFE,
    productCodes: {
      CPL100: 'CPL100',
      CPL100A: 'CPL100A',
      CPL65: 'CPL65',
      CPL65A: 'CPL65A',
      CPL10: 'CPL10',
      CPL10A: 'CPL10A',
      CPL12: 'CPL12',
      CPL15: 'CPL15',
      CPL15A: 'CPL15A',
      CPL20: 'CPL20',
      CPL20A: 'CPL20A',
    },
    productNames: {
      CPL100: 'Whole Life 100',
      CPL100A: 'Whole Life 100',
      CPL65: 'Whole Life 65',
      CPL65A: 'Whole Life 65',
      CPL10: 'Whole Life 10',
      CPL10A: 'Whole Life 10',
      CPL12: 'Whole Life 12',
      CPL15: 'Whole Life 15',
      CPL15A: 'Whole Life 15',
      CPL20: 'Whole Life 20',
      CPL20A: 'Whole Life 20',
    },
  },
  Sanderling: {
    productCodes: {
      MMTRADWL100: 'MMTRADWL100',
      MMTRADWL65: 'MMTRADWL65',
      MMTRADWL20: 'MMTRADWL20',
    },
  },
  Annuity: {
    code: 'Annuity',
    name: 'Annuity',
    group: productGroups.ANNUITY,
    productCodes: {
      CASREC: 'CASREC',
      CASRE: 'CASRE',
      CASSV: 'CASSV',
    },
    productNames: {
      CASREC: 'RetireEase Choice',
      CASRE: 'RetireEase',
      CASSV: 'Stable Voyage',
    },
  },
  DI: {
    code: 'DI',
    name: 'Disability',
    group: productGroups.DI,
    productCodes: {
      MMDI: 'MMDI',
    },
  },
};

const policyRanges = {
  CASTerm: {
    start: 400000000,
    end: 400999999,
  },
  CASTermECP: {
    start: 403000000,
    end: 403499999,
  },
  MMDirectTerm: {
    start: 1100600001,
    end: 1100999999,
  },
  MMDirectTermECP: {
    start: 404000000,
    end: 404999999,
  },
  ET10: {
    start: 406000000,
    end: 406999999,
  },
  ET03: {
    start: 406100000,
    end: 406999999,
  },
  CPL100: {
    start: 402000000,
    end: 402999999,
  },
  CPL65: {
    start: 405000000,
    end: 405999999,
  },
  CPL10: {
    start: 408000000,
    end: 408499999,
  },
  CPL12: {
    start: 408500000,
    end: 408999999,
  },
  CPL15: {
    start: 409000000,
    end: 409499999,
  },
  CPL20: {
    start: 409500000,
    end: 409999999,
  },
  CASREC: {
    start: 415000000,
    end: 415249999,
  },
  CASRE: {
    start: 415500000,
    end: 415749999,
  },
  CASSV: {
    start: 416000000,
    end: 416499999,
  },
  MMTRADTerm: {
    start: 21000000,
    end: 24699999,
  },
  MMTRADTermECP: {
    start: 21000000,
    end: 24699999,
  },
  MMOPMTerm: {
    start: 21000000,
    end: 24699999,
  },
  MMOPMTermAPT80: {
    start: 21000000,
    end: 24699999,
  },
  MMTRADWL100: {
    start: 21000000,
    end: 24699999,
  },
  MMTRADWL65: {
    start: 21000000,
    end: 24699999,
  },
  MMTRADWL20: {
    start: 21000000,
    end: 24699999,
  },
};

const cpTermMinAge = 17.5;

export const productSpecs = {
  CASTerm: {
    minFace: 1e5,
    maxFace: 3e6,
    maxFaceForTLIC: 1e6,
    maxFaceForInstant: 1e6,
    maxFaceForHigherAge: 1e6,
    maxAgeForHigherFace: 59.5,
    maxFaceForNoncitizens: 1e6,
    maxFaceForAlgoGate: 3e6,
    minTerm: 10,
    minAge: cpTermMinAge,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    termBreakdown: {
      1: {
        maxAge: 65,
      },
      10: {
        maxAge: 65,
      },
      15: {
        maxAge: 65,
      },
      20: {
        maxAge: 65,
      },
      25: {
        maxAge: 60,
        tobaccoMaxAge: 55,
      },
      30: {
        maxAge: 55,
        tobaccoMaxAge: 50,
      },
    },
  },
  CASTermECP: {
    minFace: 1e5,
    maxFace: 3e6,
    maxFaceForTLIC: 1e6,
    maxFaceForInstant: 1e6,
    maxFaceForNoncitizens: 1e6,
    maxFaceForAlgoGate: 3e6,
    minAge: cpTermMinAge,
    maxAge: 54,
    minTerm: 15,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    termBreakdown: {
      15: {
        maxAge: 54,
      },
      20: {
        maxAge: 54,
      },
      25: {
        maxAge: 54,
      },
      30: {
        maxAge: 54,
        tobaccoMaxAge: 44,
      },
    },
  },
  CPL100: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForNoncitizens: 1e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    maxAgeForHigherFace: 59.5,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 100,
    termBreakdown: {
      100: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL100A: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForNoncitizens: 1e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    maxAgeForHigherFace: 59.5,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 100,
    termBreakdown: {
      100: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL65: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForNoncitizens: 1e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 50,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 65,
    termBreakdown: {
      65: [
        {
          faceUpTo: 1e6,
          maxAge: 50,
        },
        {
          faceUpTo: 3e6,
          maxAge: 50,
        },
      ],
    },
  },
  CPL65A: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForNoncitizens: 1e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 50,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 65,
    termBreakdown: {
      65: [
        {
          faceUpTo: 1e6,
          maxAge: 50,
        },
        {
          faceUpTo: 3e6,
          maxAge: 50,
        },
      ],
    },
  },
  CPL10: {
    minFace: 1e5, // 100K
    maxFace: 3e6, // 3M
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 10,
    termBreakdown: {
      10: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL10A: {
    minFace: 1e5, // 100K
    maxFace: 3e6, // 3M
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 10,
    termBreakdown: {
      10: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL12: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 12,
    termBreakdown: {
      12: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL15: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 15,
    termBreakdown: {
      15: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL15A: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 15,
    termBreakdown: {
      15: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL20: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 20,
    termBreakdown: {
      20: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  CPL20A: {
    minFace: 25e3,
    maxFace: 3e6,
    maxFaceForInstant: 1e6,
    maxFaceForAlgoGate: 3e6,
    maxFaceForHigherAge: 1e6,
    minAge: 0,
    maxAge: 65,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility',
    tableRatingsEnabled: true,
    term: 20,
    termBreakdown: {
      20: [
        {
          faceUpTo: 1e6,
          maxAge: 65,
        },
        {
          faceUpTo: 3e6,
          maxAge: 59.5,
        },
      ],
    },
  },
  ET10: {
    lifeBridgeNotificationIncomeMin: 10e3,
    lifeBridgeNotificationIncomeMax: 40e3,
  },
  ET03: {
    lifeBridgeNotificationIncomeMin: 10e3,
    lifeBridgeNotificationIncomeMax: 40e3,
  },
  AllProductAge: {
    minAge: 0,
    minTermAge: cpTermMinAge,
    maxAge: 65,
    maxAgeForHigherFace: 59.5,
  },
  MMTRADTerm: {
    minFace: 1e5,
    maxFace: 3e6,
    minTerm: 1,
    minAge: 18,
    maxAge: 75,
    flatExtraMax: 20,
    temporaryFlatExtra: true,
    availableRiders: 'Waiver of Premium, ADBR',
    tableRatingsEnabled: true,
    termBreakdown: {
      1: {
        maxAge: 75,
      },
      10: {
        maxAge: 65,
      },
      20: {
        maxAge: 65,
      },
    },
  },
  MMTRADTermECP: {
    minFace: 1e5,
    maxFace: 3e6,
    minTerm: 1,
    minAge: 18,
    maxAge: 54,
    flatExtraMax: 20,
    temporaryFlatExtra: true,
    availableRiders: 'Waiver of Premium, ADBR',
    tableRatingsEnabled: true,
    termBreakdown: {
      15: {
        maxAge: 54,
      },
      20: {
        maxAge: 54,
      },
      25: {
        maxAge: 54,
      },
      30: {
        maxAge: 54,
      },
    },
  },
  MMOPMTermAPT80: {
    minFace: 1e5,
    maxFace: 5e6,
    minTerm: 1,
    minAge: 18,
    maxAge: 69,
    flatExtraMax: 20,
    temporaryFlatExtra: true,
    availableRiders: 'Waiver of Premium, ADBR',
    tableRatingsEnabled: true,
    termBreakdown: {
      1: {
        maxAge: 55,
      },
    },
  },
  MMOPMTerm: {
    minFace: 1e5,
    maxFace: 3e6,
    minTerm: 20,
    minAge: 18,
    maxAge: 65,
    flatExtraMax: 20,
    temporaryFlatExtra: true,
    availableRiders: 'Waiver of Premium, ADBR',
    tableRatingsEnabled: true,
    termBreakdown: {
      20: {
        99: {
          maxAge: 59,
        },
        2006: {
          maxAge: 55,
        },
      },
    },
  },
  MMTRADWL100: {
    minFace: 25e3,
    maxFace: 3e6,
    minAge: 0,
    maxAge: 90,
    flatExtraMax: 5,
    temporaryFlatExtra: false,
    availableRiders: 'Waiver of Premium, Convertibility, GIR, ALIR, ADBR, RTR, TIR',
    tableRatingsEnabled: true,
    term: 100,
    termBreakdown: {
      100: {
        faceUpTo: 3e6,
        maxAge: 90,
      },
    },
  },
  MMTRADWL65: {
    minFace: 25e3,
    maxFace: 3e6,
    minAge: 0,
    maxAge: 60,
    flatExtraMax: 5,
    temporaryFlatExtra: true,
    availableRiders: 'Waiver of Premium, Convertibility, GIR, ALIR, ADBR, RTR, TIR',
    tableRatingsEnabled: true,
    term: 65,
    termBreakdown: {
      65: [
        {
          faceUpTo: 3e6,
          maxAge: 60,
        },
      ],
    },
  },
  MMTRADWL20: {
    minFace: 25e3,
    maxFace: 3e6,
    minAge: 0,
    maxAge: 75,
    flatExtraMax: 5,
    temporaryFlatExtra: true,
    availableRiders: 'Waiver of Premium, Convertibility, GIR, ALIR, ADBR, RTR, TIR',
    tableRatingsEnabled: true,
    term: 20,
    termBreakdown: {
      20: [
        {
          faceUpTo: 3e6,
          maxAge: 75,
        },
      ],
    },
  },
};

const quoteEngineKeys = {
  CASTerm: {
    quoteKey: 'CASTerm',
    waiverKey: 'CASTerm',
  },
  CASTermECP: {
    quoteKey: 'CASTermECP',
    waiverKey: 'CASTermECP',
  },
  CPL100: {
    quoteKey: 'CPL100',
    waiverKey: 'CPL100',
  },
  CPL100A: {
    quoteKey: 'CPL100A',
    waiverKey: 'CPL100A',
  },
  CPL65: {
    quoteKey: 'CPL65',
    waiverKey: 'CPL65',
  },
  CPL65A: {
    quoteKey: 'CPL65A',
    waiverKey: 'CPL65A',
  },
  CPL10: {
    quoteKey: 'CPL10',
    waiverKey: 'CPL10',
  },
  CPL10A: {
    quoteKey: 'CPL10A',
    waiverKey: 'CPL10A',
  },
  CPL12: {
    quoteKey: 'CPL12',
    waiverKey: 'CPL12',
  },
  CPL15: {
    quoteKey: 'CPL15',
    waiverKey: 'CPL15',
  },
  CPL15A: {
    quoteKey: 'CPL15A',
    waiverKey: 'CPL15A',
  },
  CPL20: {
    quoteKey: 'CPL20',
    waiverKey: 'CPL20',
  },
  CPL20A: {
    quoteKey: 'CPL20A',
    waiverKey: 'CPL20A',
  },
  MMDirectTerm: {
    quoteKey: 'MMDirectTerm',
    waiverKey: 'MMDirectTerm',
  },
  MMDirectTermECP: {
    quoteKey: 'MMDirectTermECP',
    waiverKey: 'MMDirectTermECP',
  },
  ET10: {
    quoteKey: 'ET10',
    waiverKey: 'ET10',
  },
  ET03: {
    quoteKey: 'ET03',
    waiverKey: 'ET03',
  },
  MMTRADTerm: {
    quoteKey: 'MMTRADTerm',
    waiverKey: 'MMTRADTerm',
  },
  MMOPMTerm: {
    quoteKey: 'MMOPMTerm',
    waiverKey: 'MMOPMTerm',
  },
  MMOPMTermAPT80: {
    quoteKey: 'MMOPMTermAPT80',
    waiverKey: 'MMOPMTermAPT80',
  },
  MMTRADTermECP: {
    quoteKey: 'MMTRADTermECP',
    waiverKey: 'MMTRADTermECP',
  },
  MMTRADWL100: {
    quoteKey: 'MMTRADWL100',
    waiverKey: 'MMTRADWL100',
  },
  MMTRADWL65: {
    quoteKey: 'MMTRADWL65',
    waiverKey: 'MMTRADWL65',
  },
  MMTRADWL20: {
    quoteKey: 'MMTRADWL20',
    waiverKey: 'MMTRADWL20',
  },
};

const platforms = {
  Coverpath: {
    channels: [channels.CAS.code, channels.MMDirect.code, channels.LifeBridge.code],
  },
};

const products = {
  CASTerm: {
    artDescription: 'Annually Renewable Term',
    artDescriptionShort: 'ART',
    code: 'CASTerm',
    name: 'MassMutual Convertible Term',
    type: productTypes.Term,
    channel: channels.CAS,
    policyRange: policyRanges.CASTerm,
    quoteKey: quoteEngineKeys.CASTerm,
    convertible: true,
    productSpecs: productSpecs.CASTerm,
    shortName: `Term $Term$`,
    longName: `Convertible Term $Term$`,
  },
  CASTermECP: {
    artDescription: 'Annually Renewable Term ECP',
    artDescriptionShort: 'ART ECP',
    code: 'CASTermECP',
    name: 'MassMutual Convertible Term',
    type: productTypes.Term,
    channel: channels.CAS,
    policyRange: policyRanges.CASTermECP,
    quoteKey: quoteEngineKeys.CASTermECP,
    convertible: true,
    productSpecs: productSpecs.CASTermECP,
    shortName: `Term $Term$ ECP`,
    longName: `Convertible Term $Term$ ECP`,
  },
  CPL100: {
    code: 'CPL100',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL100,
    quoteKey: quoteEngineKeys.CPL100,
    convertible: true,
    productSpecs: productSpecs.CPL100,
    shortName: `WL $Term$`,
    longName: `Whole Life $Term$`,
  },
  CPL100A: {
    code: 'CPL100A',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL100,
    quoteKey: quoteEngineKeys.CPL100A,
    convertible: true,
    productSpecs: productSpecs.CPL100A,
    shortName: `WL $Term$`,
    longName: `Whole Life $Term$`,
  },
  CPL65: {
    code: 'CPL65',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL65,
    quoteKey: quoteEngineKeys.CPL65,
    convertible: true,
    productSpecs: productSpecs.CPL65,
  },
  CPL65A: {
    code: 'CPL65A',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL65,
    quoteKey: quoteEngineKeys.CPL65A,
    convertible: true,
    productSpecs: productSpecs.CPL65A,
  },
  CPL10: {
    code: 'CPL10',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL10,
    quoteKey: quoteEngineKeys.CPL10,
    convertible: true,
    productSpecs: productSpecs.CPL10,
  },
  CPL10A: {
    code: 'CPL10A',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL10,
    quoteKey: quoteEngineKeys.CPL10A,
    convertible: true,
    productSpecs: productSpecs.CPL10A,
  },
  CPL12: {
    code: 'CPL12',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL12,
    quoteKey: quoteEngineKeys.CPL12,
    convertible: true,
    productSpecs: productSpecs.CPL12,
  },
  CPL15: {
    code: 'CPL15',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL15,
    quoteKey: quoteEngineKeys.CPL15,
    convertible: true,
    productSpecs: productSpecs.CPL15,
  },
  CPL15A: {
    code: 'CPL15A',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL15,
    quoteKey: quoteEngineKeys.CPL15A,
    convertible: true,
    productSpecs: productSpecs.CPL15A,
  },
  CPL20: {
    code: 'CPL20',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL20,
    quoteKey: quoteEngineKeys.CPL20,
    convertible: true,
    productSpecs: productSpecs.CPL20,
  },
  CPL20A: {
    code: 'CPL20A',
    name: 'MassMutual Whole Life',
    type: productTypes.Whole,
    channel: channels.CAS,
    policyRange: policyRanges.CPL20,
    quoteKey: quoteEngineKeys.CPL20A,
    convertible: true,
    productSpecs: productSpecs.CPL20A,
  },
  MMDirectTerm: {
    code: 'MMDirectTerm',
    name: 'MassMutual Direct Term',
    type: productTypes.Term,
    channel: channels.MMDirect,
    policyRange: policyRanges.MMDirectTerm,
    quoteKey: quoteEngineKeys.MMDirectTerm,
    convertible: true,
    productSpecs: productSpecs.CASTerm,
  },
  MMDirectTermECP: {
    artDescription: 'Annually Renewable Term ECP',
    artDescriptionShort: 'ART ECP',
    code: 'MMDirectTermECP',
    name: 'MassMutual Direct Term',
    type: productTypes.Term,
    channel: channels.MMDirect,
    policyRange: policyRanges.MMDirectTermECP,
    quoteKey: quoteEngineKeys.MMDirectTermECP,
    convertible: true,
    productSpecs: productSpecs.CASTermECP,
    shortName: `Term $Term$ ECP`,
    longName: `Convertible Term $Term$ ECP`,
  },
  ET10: {
    code: 'ET10',
    name: 'LifeBridge',
    type: productTypes.Term,
    channel: channels.LifeBridge,
    policyRange: policyRanges.ET10,
    quoteKey: quoteEngineKeys.ET10,
    convertible: true,
    productSpecs: productSpecs.CASTermECP,
  },
  CASREC: {
    code: 'CASREC',
    name: 'MassMutual RetireEase Choice',
    type: productTypes.Annuity,
    channel: channels.CAS,
    policyRange: policyRanges.CASREC,
  },
  CASRE: {
    code: 'CASRE',
    name: 'MassMutual RetireEase',
    type: productTypes.Annuity,
    channel: channels.CAS,
    policyRange: policyRanges.CASRE,
  },
  CASSV: {
    code: 'CASSV',
    name: 'MassMutual Stable Voyage',
    type: productTypes.Annuity,
    channel: channels.CAS,
    policyRange: policyRanges.CASSV,
  },
  MMTRADTerm: {
    artDescription: 'Vantage Annually Renewable Term',
    artDescriptionShort: 'Vantage ART',
    code: 'MMTRADTerm', //For sanderling product, we are using `MMTRADTerm`; For sanderling channel, we are uing `MMTRAD`.
    name: 'Vantage Term',
    type: productTypes.Term,
    channel: channels.MMTRAD,
    policyRange: policyRanges.MMTRADTerm,
    quoteKey: quoteEngineKeys.MMTRADTerm,
    convertible: true,
    productSpecs: productSpecs.MMTRADTerm,
    shortName: `Vantage Term $Term$`,
    longName: `Vantage Term $Term$`,
  },
  MMOPMTerm: {
    code: 'MMOPMTerm',
    name: 'Term 20 Guaranteed',
    type: productTypes.Term,
    channel: channels.MMOPM,
    quoteKey: quoteEngineKeys.MMOPMTerm,
    convertible: true,
    productSpecs: productSpecs.MMOPMTerm,
    shortName: `Term 20 Guaranteed`,
    longName: `Term 20 Guaranteed`,
  },
  MMOPMTermAPT80: {
    artDescription: 'Annually Renewable Term',
    artDescriptionShort: 'ART',
    code: 'MMOPMTermAPT80',
    name: 'APT80',
    type: productTypes.Term,
    channel: channels.MMOPM,
    quoteKey: quoteEngineKeys.MMOPMTermAPT80,
    convertible: true,
    productSpecs: productSpecs.MMOPMTermAPT80,
    shortName: `ART`,
    longName: `Annually Renewable Term`,
  },
  MMTRADTermECP: {
    artDescription: 'Vantage Annually Renewable Term ECP',
    artDescriptionShort: 'Vantage ART ECP',
    code: 'MMTRADTermECP', //For sanderling product
    name: 'Vantage Term',
    type: productTypes.Term,
    channel: channels.MMTRAD,
    policyRange: policyRanges.MMTRADTermECP,
    quoteKey: quoteEngineKeys.MMTRADTermECP,
    convertible: true,
    productSpecs: productSpecs.MMTRADTermECP,
    shortName: `Vantage Term $Term$ ECP`,
    longName: `Vantage Term $Term$ ECP`,
  },
  MMTRADWL100: {
    code: 'MMTRADWL100', //For sanderling product
    name: 'MassMutual Whole Life Legacy',
    type: productTypes.Whole,
    channel: channels.MMTRAD,
    policyRange: policyRanges.MMTRADWL100,
    quoteKey: quoteEngineKeys.MMTRADWL100,
    convertible: true,
    productSpecs: productSpecs.MMTRADWL100,
    shortName: 'WL Legacy 100',
    longName: 'Whole Life Legacy 100',
  },
  MMTRADWL65: {
    code: 'MMTRADWL65', //For sanderling product
    name: 'MassMutual Whole Life Legacy',
    type: productTypes.Whole,
    channel: channels.MMTRAD,
    policyRange: policyRanges.MMTRADWL65,
    quoteKey: quoteEngineKeys.MMTRADWL65,
    convertible: true,
    productSpecs: productSpecs.MMTRADWL65,
    shortName: 'WL Legacy 65',
    longName: 'Whole Life Legacy 65',
  },
  MMTRADWL20: {
    code: 'MMTRADWL20', //For sanderling product
    name: 'MassMutual Whole Life Legacy',
    type: productTypes.Whole,
    channel: channels.MMTRAD,
    policyRange: policyRanges.MMTRADWL20,
    quoteKey: quoteEngineKeys.MMTRADWL20,
    convertible: true,
    productSpecs: productSpecs.MMTRADWL20,
    shortName: 'WL Legacy 20 Pay',
    longName: 'Whole Life Legacy 20 Pay',
  },
};

const product = {
  branding: branding,

  carrier: carrier,

  productGroups: productGroups,

  productTypes: productTypes,

  channelGroups: channelGroups,

  channels: channels,

  policyRanges: policyRanges,

  productSpecs: productSpecs,

  quoteEngineKeys: quoteEngineKeys,

  products: products,

  platforms: platforms,
};

export const Product = product;

export const productEligibileForFaceIncreaseIllustration = [
  Product.productTypes.Whole.productCodes.CPL100,
  Product.productTypes.Whole.productCodes.CPL100A,
  Product.productTypes.Whole.productCodes.CPL65,
  Product.productTypes.Whole.productCodes.CPL65A,
  Product.productTypes.Sanderling.productCodes.MMTRADWL100,
  Product.productTypes.Sanderling.productCodes.MMTRADWL65,
  Product.productTypes.Sanderling.productCodes.MMTRADWL20,
];

export const MinimumFaceIncreaseInterval = 25000;

export const TimeFrequency = {
  'annual': 'year',
  'monthly': 'month',
  'semi-annual': 'semi-annually',
  'quarterly': 'quarter',
};

export const FrequencyUnit = {
  Annual: 'yr',
  Monthly: 'mo',
};

/**
 * only certain properties affect the waiver of premium amount
 */
export const PropertiesForWoP = [
  'gender',
  'dob',
  'waiver',
  'state',
  'term',
  'faceAmount',
  'paymentFrequency',
  'termDisplay',
  'hasGirRider',
  'hasGirRiderBool',
  'girRiderAmount',
  'hasRtrRider',
  'hasRtrRiderBool',
  'rtrRiderAmount',
  'hasCirRider',
  'cirRiderAmount',
  'benefitDisbursementMethod',
  'hasEcp',
  'hasAlirRider',
  'additionalLifeInsuranceAmount',
];

export const PropertiesForECP = ['dob', 'term'];

export enum RiderType {
  WOP = 'Waiver of Premium',
  CONVERTIBILITY = 'Convertibility',
  GIR = 'GIR',
  RTR = 'RTR',
  ALIR = 'ALIR',
  CIR = 'CIR',
  TIR = 'TIR',
}

export enum BenefitType {
  Death = 'Death',
  Waiver = 'Waiver',
  GIR = 'GIR',
  RTR = 'RTR',
  CIR = 'CIR',
}

export const RiderConstants = {
  wop: {
    minAge: cpTermMinAge,
    maxAge: 59.5,
  },
  gir: {
    minFace: 25e3,
    maxFace: 125e3,
    maxAge: 40,
  },
  rtr: {
    minFace: 1e5,
    maxFace: 3e6,
    maxFaceForNoncitizens: 1e6,
    ageLimits: {
      default: {
        // currently CPL100, CPL100A, CPL10, CPL10A, CP12, CPL15, CPL20, CPL15A, CPL20A, CPL65A
        faceAmountSlabs: [
          {
            minAge: 17.5, //inclusive
            maxAge: 65, //exclusive
            faceUpTo: 1e6,
          },
          {
            minAge: 17.5, //inclusive
            maxAge: 59.5, //exclusive
            faceUpTo: 3e6,
          },
        ],
      },
      CPL65: {
        // override
        faceAmountSlabs: [
          {
            faceUpTo: 1e6,
            minAge: 17.5, //inclusive
            maxAge: 50, //exclusive
          },
          {
            faceUpTo: 3e6,
            minAge: 17.5, //inclusive
            maxAge: 50, //exclusive
          },
        ],
      },
    },
  },
  cir: {
    minFaceAmount: 100000,
    highFaceAmountCIRMaxPercent: 0.9,
  },
};

export const LowFaceWholeLife = {
  minFace: 25e3,
  maxFace: 50e3,
  availableProducts: ['CPL100', 'CPL100A', 'CPL65', 'CPL65A', 'CPL20', 'CPL20A', 'CPL15', 'CPL15A', 'CPL12', 'CPL10A'],
};

export const TargetPremiumProducts = ['CPL10A', 'CPL15A', 'CPL20A', 'CPL65A', 'CPL100A'];

export const TeleCMIConstants = {
  maxAgeTeleNotRequired: 60,
  maxJuviAgeTeleNotRequired: 16,
  maxFaceTeleNotRequired: 3000000,
};

export enum DividendOption {
  PUA = 'Paid-up Additions',
  CASH = 'Cash',
  PRPUA = 'Reduce Premium/Paid-up Additions',
  PRCASH = 'Reduce Premium/Cash',
  ACCUMULATE = 'Dividend Accumulations',
}

export function getWLProductCode(wholeLifeTerm: number) {
  let wlProductCode: string = `CPL${wholeLifeTerm}`;
  if (wholeLifeTerm !== 12) {
    wlProductCode = wlProductCode + 'A';
  }
  return wlProductCode;
}

export const productsEligibleForFaceIncreaseIllustration = [
  'CPL100',
  'CPL100A',
  'CPL65',
  'CPL65A',
  'MMTRADWL100',
  'MMTRADWL65',
  'MMTRADWL20',
];
